import React from 'react';

export function PanelRightIcon() {
  // https://lucide.dev/icons/panel-right
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path d="M15 3v18" />
    </g>
  );
}
